module.exports = __webpack_public_path__ + "static/media/Lobb-Bg.399dec6e.jpg";